import MSinglex from './index.vue';
import MSinglexItem from './item.vue';

export {
    MSinglex,
    MSinglexItem,
};

export default MSinglex;
